import React from "react";

const PrivacyPolicy = ({schoolName}) => {
console.log(`schoolName: ${schoolName}`);
    return (
        <div className="bg-gray-50 text-gray-800 min-h-screen py-8 px-6 md:px-16">
            <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-lg p-8">
                <h1 className="text-3xl font-bold text-gray-900 mb-4">Privacy Policy</h1>
                <p className="text-sm text-gray-500 mb-8">
                    <strong>Effective Date:</strong> 2024-12-11
                </p>
                <p className="text-lg text-gray-700 mb-6">
                    <strong>{schoolName}</strong> ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, and disclose information when you use our mobile application, {schoolName} ("App"), and the services available through the App.
                </p>

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">1. Information We Collect</h2>

                <h3 className="text-xl font-semibold text-gray-800 mb-2">1.1 Personal Information</h3>
                <ul className="list-disc list-inside text-gray-700 mb-6">
                    <li>Name</li>
                    <li>Email address</li>
                    <li>Phone number</li>
                    <li>School details</li>
                </ul>

                <h3 className="text-xl font-semibold text-gray-800 mb-2">1.2 Camera Access</h3>
                <p className="text-gray-700 mb-6">
                    The App requires access to your device's camera for creating and submitting assignments, notes, and other educational content. We do not store or share images or videos taken using the camera beyond the scope of the App's functionality.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-2">1.3 Location Access</h3>
                <p className="text-gray-700 mb-6">
                    The App may require access to your device's location information if you log in using a Bus Driver profile. This information is used solely for tracking and managing bus routes and ensuring the safety of students during transportation. Location data is not shared or used beyond this functionality.
                </p>

                <h3 className="text-xl font-semibold text-gray-800 mb-2">1.4 Usage Data</h3>
                <ul className="list-disc list-inside text-gray-700 mb-6">
                    <li>Log data (e.g., IP address, device type, operating system)</li>
                    <li>App usage data (e.g., features used, pages visited, time spent on the App)</li>
                </ul>

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">2. How We Use Your Information</h2>
                <ul className="list-disc list-inside text-gray-700 mb-6">
                    <li>To provide, maintain, and improve the App and our services</li>
                    <li>To communicate with you, including sending updates and notifications</li>
                    <li>To ensure the security and integrity of our services</li>
                    <li>To comply with legal obligations</li>
                </ul>

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">3. Sharing Your Information</h2>
                <ul className="list-disc list-inside text-gray-700 mb-6">
                    <li>With your consent</li>
                    <li>To comply with legal obligations</li>
                    <li>With service providers who assist us in operating the App (e.g., hosting providers, analytics services)</li>
                </ul>

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">4. Security</h2>
                <p className="text-gray-700 mb-6">
                    We take reasonable measures to protect your information from unauthorized access, use, or disclosure. However, no internet-based service can be completely secure.
                </p>

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">5. Your Rights</h2>
                <ul className="list-disc list-inside text-gray-700 mb-6">
                    <li>Access and update your personal information</li>
                    <li>Request the deletion of your personal information</li>
                    <li>Object to the processing of your personal information</li>
                    <li>Withdraw your consent at any time</li>
                </ul>

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">6. Children's Privacy</h2>
                <p className="text-gray-700 mb-6">
                    We do not knowingly collect personal information from children under the age of 13 without parental consent. If you believe we have collected information from a child under 13, please contact us to delete such information.
                </p>

                <h2 className="text-2xl font-semibold text-gray-900 mb-4">7. Changes to This Privacy Policy</h2>
                <p className="text-gray-700">
                    We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy within the App.
                </p>
            </div>
        </div>
    );
};

export default PrivacyPolicy;